import { ProviderAccount } from '@prisma/client'
import { Modal } from 'antd'
import { ProviderClient } from '~/plugins/data-connector/providers/abstract/provider.client'
import { FormConnect } from '../FormConnect'

type Props = {
  isOpen: boolean
  provider: ProviderClient
  providerAccount?: ProviderAccount
  onSubmit: (account: ProviderAccount) => void
  onSubmitInput: (values: any) => void
  onCancel: () => void
}

export const ModalAuthentication: React.FC<Props> = ({
  isOpen,
  provider,
  providerAccount,
  onSubmit,
  onSubmitInput,
  onCancel,
}) => {
  return (
    <Modal open={isOpen} onCancel={onCancel} footer={null}>
      {isOpen && (
        <FormConnect
          account={providerAccount}
          provider={provider}
          onSubmit={onSubmit}
          onSubmitInput={onSubmitInput}
        />
      )}
    </Modal>
  )
}
